import React from 'react';
import { I18n } from 'i18n';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { Container, Content } from 'components';
import { Table as TableUI } from 'antd';
import { Filters } from './filters';
import { useOverviewPower } from 'apollo/power';
import { timeToMinutes } from 'utils';

const stateName = 'electric.power.log';

export function Log() {
  const {
    electric: {
      power: { log },
    },
  } = useSelector(({ state }) => state);
  const { data, loading } = useOverviewPower(log);
  return (
    <Container>
      <Filters stateName={stateName} />
      <Content>
        {loading && !data.length ? (
          <Spin spinning={loading} />
        ) : (
          <TableUI
            dataSource={data}
            bordered
            scroll={{ y: 550 }}
            tableLayout="auto"
            size="small"
            pagination={false}
            rowKey={(data) => data._id + data.day + data.hours}
            columns={columns(data)}
          />
        )}
      </Content>
    </Container>
  );
}

function columns(data = []) {
  let columns = [];
  columns.push({
    title: I18n('hour', true),
    key: 'hours_apo',
    dataIndex: 'hours_apo',
    // filters: findFilters(data, 'hours_apo'),
    // onFilter: (value, record) => record['hours_ori'] === value,
    sorter: (a, b) => timeToMinutes(a.hours_apo) - timeToMinutes(b.hours_apo),
  });

  columns.push({
    title: I18n('amperage', true),
    key: 'amperage',
    dataIndex: 'amperage',
    // filters: findFilters(data, 'amperage'),
    // onFilter: (value, record) => record['amperage'] === value,
    sorter: (a, b) => a.amperage - b.amperage,
  });

  columns.push({
    title: I18n('voltage', true),
    key: 'voltage',
    dataIndex: 'voltage',
    // filters: findFilters(data, 'voltage'),
    // onFilter: (value, record) => record['voltage'] === value,
    sorter: (a, b) => a.voltage - b.voltage,
  });

  return columns;
}

// function findFilters(data, key) {
//   let out = data.map((item) => item[key]);
//   out = [...new Set(out)].sort();
//   return out.map((value) => ({ text: value, value }));
// }
